export const calculateOrcLoss = (damage) => {
  const groupsOfThree = Math.floor(damage / 3);
  const remainder = damage % 3;

  let loss = groupsOfThree * 2; // за каждые 3 урона теряем 2 численности

  if (remainder === 2) {
    loss += 1; // за оставшиеся 2 урона теряем 1
  }

  return loss;
}